require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /home/mudassir/.nvm/v8.7.0/lib/node_modules/react-scripts/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 1016
// module chunks = 0